import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { QuestionRangeGroupWeightingValue } from "./question-range-group-weighting-value.model";

export class QuestionRangeGroupWeighting extends BaseModel {
  id: number;
  name: string;
  description: string;
  qRangeGroupId: number;
  @Type(() => QuestionRangeGroupWeightingValue)
  qRangeGroupWValues: QuestionRangeGroupWeightingValue[];
  /** Questions referencing this weighting. Non-zero withholds Edit and Delete. */
  questionCount: number;
  /** Distinct questionnaires containing a question that uses this weighting. Displayed only. */
  questionnaireCount?: number;
  getQuestionWeightingByQuestionRangeValue(rangeValue: number): number {
    return this.qRangeGroupWValues.find((q) => q.qRangeValue === rangeValue)?.weightedValue || 0;
  }
}
